'use client';

import React from 'react';
import clsx from 'clsx';
import { Trans } from '@lingui/react/macro';
import { UIComponent } from '@/components/core/components';
import { Element, Image } from '@/components/core/components/atoms';
import * as styles from './feed-footer.styles';
import { useFeed } from '../context/context';

const FeedFooter: UIComponent = ({ children }) => {
  const { comment, product, recommendation } = useFeed();
  if (!product) {
    return null;
  }

  return (
    <footer className={clsx(styles.footer)}>
      {children || (
        <>
          {(comment?.message || recommendation?.message) && (
            <div className={styles.comment}>
              <Element lines={3}>{`"${comment?.message || recommendation?.message}"`}</Element>
            </div>
          )}
          {product.providers && (
            <div className={clsx(styles.availableIn, { invisible: product.providers.length === 0 })}>
              <Trans>Available in:</Trans>
              <div className={styles.providers}>
                {product.providers.map((provider) => {
                  return (
                    <a className={styles.providerLogo} href={provider.url} target="_blank" rel="noopener nofollow" key={provider.name}>
                      <Image alt={provider.name} src={provider.logo} />
                    </a>
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}
    </footer>
  );
};

export default FeedFooter;
